import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MonitoringFiltersFieldComponent } from './filters-field/monitoring-filters-field.component';
import { IntrackFeatureModule } from '../../../intrack-feature.module';
import { DatepickerModule } from '../../datepicker/datepicker.module';
import { MonitoringSelectProfileComponent } from './select-profile/monitoring-select-profile.component';
import { MonitoringFiltersComponent } from './monitoring-filters.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ActionButtonModule } from '../../action-button/action-button.module';
import { MonitoringProfileCreateDialogComponent } from './profile-dialog/monitoring-profile-create-dialog.component';
import { MonitoringPageComponent } from './page/monitoring-page.component';
import { MonitoringPageService } from './page/monitoring-page.service';
import { MatChipsFilterDialogComponent } from './filters-field/mat-chips-filter-dialog/mat-chips-filter-dialog.component';
import { NgxsModule } from '@ngxs/store';
import { ReasonCodeState } from '../../../store/state/monitoring/reason-code/reason-code.state';
import { MatTooltipModule } from '@angular/material/tooltip';
import { StatusCodeState } from '../../../store/state/monitoring/status-code/status-code.state';
import { PipesModule } from '../../../common/pipes/pipes.module';
import { CompartmentDocksFilterSelectionDialogComponent } from './filters-field/compartment-docks-filter-selection-dialog/compartment-docks-filter-selection-dialog.component';
import { MonitoringProfilesModule } from '../profiles/monitoring-profiles.module';
import { MonitoringReportModule } from '../report/monitoring-report.module';
import { DateTimeRangeModule } from '../../date-time-range/date-time-range.module';
import { ChipsWithSearchModule } from '../../chips-with-search/chips-with-search.module';
import { ShipmentMonitoringFiltersComponent } from './shipment-montoring-filters/shipment-monitoring-filters.component';
import { CombinedDateTimeRangeModule } from '../../combined-date-time-range/combined-date-time-range.module';
import { ControlBorderedWrapperModule } from '../../control-bordered-wrapper';
import { UserRolesFilterDialogComponent } from './filters-field/user-roles-filters-dialog/user-roles-filter-dialog.component';
import { HubsFilterDialogComponent } from './filters-field/hubs-filters-dialog/hubs-filter-dialog.component';
import { ListFilterModule } from '../../list-filter';
import { SelectSearchModule } from '../../select-search/select-search.module';
import { PartnersSelectionFilterDialogComponent } from './filters-field/partners-filter-dialog/partners-selection-filter-dialog.component';
import { FilterOptionsState } from '../../../store';
import { SvgIconModule } from '../../svg-icon/svg-icon.module';
import { MonitoringListViewToolbarComponent } from './list-view-toolbar/monitoring-list-view-toolbar.component';
import { MonitoringListChipsToolbarComponent } from './filter-chip-list/monitoring-list-chips-toolbar.component';
import { MonitoringFiltersStickyHeaderDirective } from './directives/monitoring-filters-sticky-header.directive';

@NgModule({
  declarations: [
    MonitoringProfileCreateDialogComponent,
    MonitoringFiltersFieldComponent,
    MonitoringSelectProfileComponent,
    MonitoringFiltersComponent,
    MonitoringPageComponent,
    MatChipsFilterDialogComponent,
    CompartmentDocksFilterSelectionDialogComponent,
    ShipmentMonitoringFiltersComponent,
    UserRolesFilterDialogComponent,
    HubsFilterDialogComponent,
    PartnersSelectionFilterDialogComponent,
    MonitoringListViewToolbarComponent,
    MonitoringListChipsToolbarComponent,
    MonitoringFiltersStickyHeaderDirective,
  ],
  imports: [
    IntrackFeatureModule,
    DatepickerModule,
    ActionButtonModule,
    DragDropModule,
    PipesModule,
    TranslateModule.forChild({}),
    NgxsModule.forFeature([ReasonCodeState, StatusCodeState, FilterOptionsState]),
    MatTooltipModule,
    MonitoringProfilesModule,
    MonitoringReportModule,
    DateTimeRangeModule,
    CombinedDateTimeRangeModule,
    ChipsWithSearchModule,
    ControlBorderedWrapperModule,
    ListFilterModule,
    SelectSearchModule,
    SvgIconModule,
  ],
  exports: [
    MonitoringProfileCreateDialogComponent,
    MonitoringFiltersFieldComponent,
    MonitoringSelectProfileComponent,
    MonitoringFiltersComponent,
    MonitoringPageComponent,
    ShipmentMonitoringFiltersComponent,
    MonitoringListViewToolbarComponent,
    MonitoringListChipsToolbarComponent,
  ],
  providers: [MonitoringPageService],
})
export class MonitoringFiltersModule {}
